import React, { useEffect, useState } from 'react'
import logo from "../assets/logo.webp"
import { Link, NavLink, useNavigate } from 'react-router-dom'
import { AiOutlineDashboard, AiOutlineLogout, AiOutlineMenu, AiOutlineSetting, AiFillCloseCircle, AiFillControl } from "react-icons/ai";
import defaultUser from "../assets/avatar.webp";
import { FaLandmark, FaPersonArrowDownToLine, FaUser, FaUserGroup, FaUserTie } from "react-icons/fa6";
import { FaHouseDamage } from "react-icons/fa";
import { SiMisskey } from "react-icons/si";
import { FcAssistant, FcBullish, FcHome, FcLibrary, FcNightPortrait, FcPortraitMode, FcWorkflow } from "react-icons/fc";
import { CgChanel } from "react-icons/cg";
import { BiSolidUserAccount } from 'react-icons/bi';
import { getSingleDataFromDatabase } from '../utils/api';
import { toast } from 'react-toastify';
import withAuth from '../utils/withAuth';
import { TbPlantOff } from 'react-icons/tb';

const Sidebar = () => {
    const navigate = useNavigate();
    const [mobileMenu, setMobileMenu] = useState(false);
    const adminid = localStorage.getItem('admindata');
    const [superadmin, setSuperadmin] = useState([]);

    const openMobileMenu = () => {
        if (mobileMenu) {
            setMobileMenu(false)
        }
        else {
            setMobileMenu(true)
        }
    }

    useEffect(() => {
        getDashboardSingleData(adminid);
    }, [adminid]);

    const getDashboardSingleData = (adminid) => {
        getSingleDataFromDatabase(`super-admin-get-single-super-admin-data/${adminid}`).then((res) => {
            if (res.data.status === 1) {
                setSuperadmin(...[res.data.superdata]);
                localStorage.setItem("superadminuniqueid", res.data.superdata?.superadmin_unique)
                localStorage.setItem("superadminname", res.data.superdata?.admin_name)
            }
            else {
                toast.error("Check you connection");
            }
        })
    }

    function logout() {
        localStorage.clear();
        navigate("/");
    }
    return (
        <div className="wrapper">
            <div className="topbarSection">
                <div className="topbar">
                    <div className="mobile-toggle-menu">
                        <Link to="/dashboard">
                            <img src={logo} alt="Logo" />
                        </Link>
                    </div>
                    <nav className="navbar navbar-expand">
                        <div className="user-box dropdown desktopDisplay">
                            <button className="d-flex align-items-center nav-link" role="button">
                                <div className="user-info ps-3">
                                    <div className="userimg">
                                        <img src={defaultUser} alt={defaultUser} />
                                    </div>
                                    <div className="username">
                                        <p className="user-name mb-0 dropdown-toggle" data-bs-toggle="dropdown">{superadmin?.admin_name}</p>
                                        <ul className="dropdown-menu">
                                            <li>
                                                <Link className="dropdown-item" to="/dashboard"><AiOutlineSetting />Settings</Link>
                                            </li>
                                            <li>
                                                <Link className="dropdown-item" onClick={logout} to="javascript:void(0)"><AiOutlineLogout />LogOut</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </button>
                        </div>
                        <div className="mobileDisplay">
                            <button onClick={openMobileMenu}>
                                {mobileMenu ?
                                    (
                                        <AiFillCloseCircle className="mobileMenuIcones" />
                                    )
                                    :
                                    (
                                        <AiOutlineMenu className="mobileMenuIcones" />
                                    )
                                }
                            </button>
                        </div>
                    </nav>
                </div>
            </div>
            <div className="sidebarWrapper desktopDisplay">
                <div className="simplebar-mask">
                    <div className="simplebar-offset">
                        <div className="simplebar-content-wrapper">
                            <div className="simplebar-content mm-active">
                                <ul className="metismenu mm-show" id="menu">
                                    <li>
                                        <NavLink activeClassName="active" to="/dashboard">
                                            <AiOutlineDashboard />
                                            <span>Dashboard</span>
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="active" to="/center-performance-report">
                                            <FcBullish />
                                            <span>Report</span>
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink activeClassName="active" to="/all-orders">
                                            <FcWorkflow />
                                            <span>All Orders</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${mobileMenu ? "" : "mobileMenuActive"}`}>
                <div className="mobilesidebarWrapper mobileDisplay">
                    <div className="simplebar-mask">
                        <div className="simplebar-offset">
                            <div className="simplebar-content-wrapper">
                                <div className="simplebar-content mm-active">
                                    <ul className="metismenu mm-show" id="menu">
                                        <li className="mm-active">
                                            <Link to="/dashboard">
                                                <AiOutlineDashboard />
                                                <span>Dashboard</span>
                                            </Link>
                                        </li>
                                        <li className="mm-active">
                                            <Link to="/dashboard">
                                                <AiOutlineSetting />
                                                <span>Settings</span>
                                            </Link>
                                        </li>
                                        <li className="mm-active">
                                            <Link onClick={logout} to="javascript:void(0)">
                                                <AiOutlineLogout />
                                                <span>LogOut</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withAuth(Sidebar)
